const baseReportsApiPath = 'organizations/:organizationId/reports';

export const reportsApiPaths = {
    reportPdf: `${baseReportsApiPath}/pdf`,
    reportStatus: `${baseReportsApiPath}/:reportId/status`,
    getReportPdf: `${baseReportsApiPath}/:reportId/pdf`,
    getPaymentConfirmationPdf: 'organizations/:organizationId/payments/:paymentId/confirmation/pdf',
    getConversionConfirmationPdf: 'organizations/:organizationId/conversions/:conversionId/confirmation/pdf',
    getFundingConfirmationPdf: 'organizations/:organizationId/fundings/:fundingId/confirmation/pdf',
    getRefundConfirmationPdf: 'organizations/:organizationId/refunds/:refundId/confirmation/pdf',
} as const;
